import { Toast } from 'primereact/toast';
import { atom } from 'jotai';

export const toastAtom = atom<Toast | null>(null);
